"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.for-each");

var _themeSections = require("@shopify/theme-sections");

var _carousel = _interopRequireDefault(require("../components/carousel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-free-reads="carousel"]',
  cell: '[js-free-reads="slide"]'
};
/**
 * Register a single featured collection section.
 * Executes on page load as well as Theme Editor `section:load` events.
 * @param {string} container - Selector for the section container DOM element.
 */

(0, _themeSections.register)('free-reads', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors: function cacheSelectors() {
    var container = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.container);
    var carousels = document.querySelectorAll('.template-page__section');
    var cells = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.cell);
    this.cache = {
      container: container,
      carousels: carousels,
      cells: cells
    };
  },

  /**
   * Check if the section has enabled the slider option.
   */
  isSliderEnabled: function isSliderEnabled() {
    return this.cache.carousels !== null;
  },

  /**
   * Construct carousel using imported Carousel component.
   */
  constructCarousel: function constructCarousel() {
    var _this = this;

    _toConsumableArray(this.cache.carousels).forEach(function (carousel, index) {
      (0, _carousel["default"])("[js-free-reads=\"carousel-".concat(index + 1, "\"]"), {
        cellSelector: _this.cache.cells,
        cellAlign: 'left',
        prevNextButtons: true,
        wrapAround: true
      }).init();
    });
  },

  /**
   * Construct new carousel on `section:load`.
   */
  onLoad: function onLoad() {
    this.cacheSelectors();

    if (this.isSliderEnabled()) {
      this.constructCarousel();
    }
  }
});